import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Get the current theme from the app's class
  const appElement = document.getElementById('app-body');
  const isLightTheme = appElement ? appElement.classList.contains('light-theme') : false;
  
  // Define text colors based on theme - improved contrast for better readability
  const textColor = isLightTheme ? '#000000' : '#ffffff';
  const linkColor = isLightTheme ? '#111111' : '#f0f0f0';
  
  const textStyle = {
    color: textColor
  };
  
  const linkStyle = {
    color: linkColor
  };
  
  const headingStyle = {
    color: '#1eb980' // Primary color for headings in both themes
  };

  return (
    <footer className="page-footer">
      <div className="container">
        <div className="row">
          <div className="col l6 s12">
            <h5 style={headingStyle}>3D Printing Services</h5>
            <p style={textStyle}>Bringing your ideas to life with precision and quality.</p>
          </div>
          <div className="col l4 offset-l2 s12">
            <h5 style={headingStyle}>Links</h5>
            <ul>
              <li><Link style={linkStyle} to="/">Home</Link></li>
              <li><Link style={linkStyle} to="/about">About</Link></li>
              <li><Link style={linkStyle} to="/contact">Contact</Link></li>
              <li><Link style={linkStyle} to="/stl-generator">STL Generator</Link></li>
              <li><Link style={linkStyle} to="/stl-models">STL Models</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container" style={textStyle}>
          2025 3D Printing Services
        </div>
      </div>
    </footer>
  );
};

export default Footer;
